import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../../components/elements/form/input";
import Teaxtarea from "../../../../components/elements/form/textarea";
import SelectBox from "../../../../components/elements/form/selectBox";
import Datepicker from "../../../../components/elements/form/datepicker";
import Button from "../../../../components/elements/button";
import { useAppLoader } from "../../../../_common/pageLoader/appLoaderHook";
import toast from "react-hot-toast";
import FileUpload from "../../../../components/elements/form/fileUplaod";
import { useDepreciationApi } from "../../../../store/api/hooks/depreciationApiHook";
import { useParams } from "react-router-dom";
import { useAssetsApi } from "../../../../store/api/hooks/assetsApiHook";
import Label from "../../../../components/elements/form/fromLabel";
import { getSelectedOption } from "../../../../_common/functions";
import moment from "moment";


interface RevaluateFormProps {
	_ref?: any;
	editData?: any;
	purchaseDate?: any;
	usefulLife?: any;
	onCreate?: () => void
	onCancel?: () => void
}

type AssetsFormValueType = {
	assetID?: number;
	revaluationID: string;
	saleAmount: string;
	lifeSpan: string;
	disposalTypeID: any;

	disposalDate: Date | null;
	extendedLifeSpan: string;

	revaluationImage: any;
	notes: string;

};

const CreateDisposal: React.FC<RevaluateFormProps> = ({ _ref, editData, purchaseDate, usefulLife, onCreate = () => { }, onCancel = () => { } }) => {

	const { control, handleSubmit, setValue, reset, formState: { errors }, watch } = useForm<AssetsFormValueType>({
		defaultValues: {}
	});
	const { showLoader, hideLoader } = useAppLoader();

	const [actualBookValue, setActualBookValue] = useState<any>(null);
	const params: any = useParams();
	const depreciationAPI = useDepreciationApi();
	const [rowDetails, setRowdetails] = useState<any>(null);
	const [disposalTypeList, setDisposalTypeList] = useState<any>(null);

	const [disableSalesAmt, setDisableSalesAmt] = useState<boolean>(false);
	const [Lifespan, setLifespan] = useState<any>(null);
	const [journalEntries, setJournalEntries] = useState<any[]>([]);
	const [minDisposalDate, setMinDisposalDate] = useState<Date | undefined>(undefined);


	const assetsAPI = useAssetsApi();
	const onSubmit: SubmitHandler<AssetsFormValueType> = (data) => {

		// Set saleAmount to 0 if disposal type is Trade In (5) and no amount is provided
		let saleAmount = data.saleAmount;
		if (data.disposalTypeID?.value === 5 && (!saleAmount || saleAmount === '')) {
			saleAmount = '0.00';
		}

		// Format disposal date to maintain timezone while ensuring correct date
		let formattedDisposalDate = null;
		if (data.disposalDate) {
			const date = new Date(data.disposalDate);
			// Adjust for timezone offset to maintain the selected date
			const timezoneOffset = date.getTimezoneOffset() * 60000;
			const localDate = new Date(date.getTime() - timezoneOffset);
			formattedDisposalDate = localDate.toISOString();
		}

		let payload: any = {
			"assetID": Number(params.id),
			"disposalDate": formattedDisposalDate,
			"saleAmount": Number(saleAmount),
			"disposalTypeID": data.disposalTypeID?.value,
			"notes": data.notes
		}

		if (editData) {
			payload['assetDisposalID'] = editData.assetDisposalID; // Add disposal ID for update
		}

		showLoader();
		depreciationAPI.SaveDisposal(payload, (resp: any) => {
			// Handle file upload if a file is selected
			if (data.revaluationImage instanceof File) {
				const formData = new FormData();
				formData.append('inputFile', data.revaluationImage);
				// Use the existing disposal ID for edits, or the returned ID for new creations
				formData.append('assetDisposalID', editData ? editData.assetDisposalID : resp?.returnID);
				depreciationAPI.SaveDisposalAttachment(formData, (resp: any) => {
					toast.success(resp?.message);
					onCreate();
					onCancel();
					formReset();
					hideLoader();
				}, (error: any) => {
					hideLoader();
					toast.error(error);
				});
			} else {
				// No file upload needed, complete the operation
				onCreate();
				onCancel();
				console.log(resp, "Submitted resp");
				toast.success(resp?.message);
				formReset();
				hideLoader();
			}
		}, (error: any) => {
			console.log('error =>', error);
			hideLoader();
			toast.error(error);
		});
		console.log("Submit payload", payload);
	};

	const watchdisposalDate = watch('disposalDate');

	const GetCurrentUsefullife = (EffectDate: Date) => {
		console.log("hhhhhhhh", EffectDate);
		
		const payload = {
			AssetID: params.id,
		};

		depreciationAPI.GetCurrentUsefullife(
			payload,
			(resp: any) => {
				const data = resp?.usefulLifeList?.[0];
				if (!data) {
					toast.error("No useful life data found.");
					return;
				}

				const endDate = new Date(data.effectiveDate);
				endDate.setFullYear(endDate.getFullYear() + data.currentUsefulLifeValue);

				const timeDiff = endDate.getTime() - EffectDate.getTime();
				const diffInDays = timeDiff / (1000 * 3600 * 24);
				const diffInMonths = diffInDays / 30.44; // Approximate average days per month
				const diffInYears = diffInMonths / 12;

				const formattedDiffInYears = Math.max(0,diffInYears).toFixed(1);
				setLifespan(formattedDiffInYears);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error("Failed to fetch useful life data.");
			}
		);
	};


	const GetJournalEntryByAssetId = () => {
		const payload = {
			assetID: params.id,
			reasonFor: 'Asset Disposal',
		};
		assetsAPI.GetJournalEntryByAssetId(
			payload,
			(resp: any) => {
				const entries = resp?.journalEntryResponseList || [];
				setJournalEntries(entries);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	const formReset = () => {
		const currentDate = new Date();
		currentDate.setDate(1);
		reset({
			disposalDate: currentDate,
			saleAmount: '',
			notes: '',
			revaluationImage: ''
		});
		setMinDisposalDate(currentDate);
		GetCurrentUsefullife(currentDate)
	}

	useEffect(() => {
		if (_ref?.current) {
			_ref.current.reset = formReset;
		}
	}, [_ref])
	useEffect(() => {
		GetJournalEntryByAssetId();
	}, [])

	useEffect(() => {
		if (editData && disposalTypeList) {
			// Debug: Log the edit data to see the sale amount
			console.log('Edit Data:', editData);
			console.log('Sale Amount from edit data:', editData.saleAmount);
			
			// Populate form with existing disposal data
			const formData = {
				disposalDate: editData.disposalDate ? new Date(editData.disposalDate) : null,
				saleAmount: editData.saleAmount !== null && editData.saleAmount !== undefined ? editData.saleAmount.toString() : '',
				notes: editData.notes || '',
				disposalTypeID: getSelectedOption(editData.disposalTypeID, disposalTypeList),
				revaluationImage: '' // Keep empty for file uploads
			};
			
			console.log('Form Data being set:', formData);
			reset(formData);
			
			// Calculate useful life for the existing disposal date
			if (editData.disposalDate) {
				setMinDisposalDate(new Date(editData.disposalDate));
				GetCurrentUsefullife(new Date(editData.disposalDate));
			}
		} else if (!editData && disposalTypeList && rowDetails) {
			// Only reset form when not in edit mode and all required data is loaded
			formReset();
		}
	}, [editData, disposalTypeList, rowDetails]);

	const setFirstDateofCurrentMonth = () => {
		const currentDate = new Date();
		currentDate.setDate(1);
		setValue("disposalDate", currentDate);
		GetCurrentUsefullife(currentDate);
	};
	const getAssetsList = (assetID: any) => {
		const payload = {
			assetID: assetID,
		};
		assetsAPI.getAssetsList(
			payload,
			(data: any) => {
				setRowdetails(data.assetList[0]);


			},
			(error: any) => { }
		);
	};

	const GetDisposalTypeList = () => {
		const payload = {};
		depreciationAPI.GetDisposalTypeList(
			payload,
			(resp: any) => {
				let disposalTypeList: any = [];
				resp.disposalTypeList.map((facilist: any) => {
					disposalTypeList.push({
						label: facilist.disposalTypeName,
						value: facilist.disposalTypeID,
						data: facilist
					});
				});
				setDisposalTypeList(disposalTypeList);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};
	useEffect(() => {
		// Only set first date of current month if not in edit mode
		if (rowDetails && !editData) {
			setFirstDateofCurrentMonth();
		}
	}, [rowDetails, editData]);

	useEffect(() => {
		if (params.id) {
			getAssetsList(params.id);
		}

	}, [params.id]);

	useEffect(() => {
		GetDisposalTypeList()

	}, []);

	const WatchDisposalTypeID = watch('disposalTypeID');

	useEffect(() => {
		console.log('Disposal Type Effect triggered:', WatchDisposalTypeID, 'Edit Mode:', !!editData);
		if (WatchDisposalTypeID) {
			if (WatchDisposalTypeID?.value == 1 || WatchDisposalTypeID?.value == 3) {
				setDisableSalesAmt(true);
				// Only set to 0.00 if not in edit mode or if current value is empty
				const currentSaleAmount = watch('saleAmount');
				console.log('Current sale amount before override:', currentSaleAmount);
				if (!editData || !currentSaleAmount) {
					console.log('Setting sale amount to 0.00');
					setValue('saleAmount', '0.00');
				} else {
					console.log('Preserving existing sale amount:', currentSaleAmount);
				}
			} else {
				setDisableSalesAmt(false);
				// Only clear the value if not in edit mode
				if (!editData) {
					console.log('Clearing sale amount (not edit mode)');
					setValue('saleAmount', '');
				} else {
					console.log('Preserving sale amount in edit mode');
				}
			}
		}
	}, [WatchDisposalTypeID, editData]);



	return (

		<form onSubmit={handleSubmit(onSubmit)} ref={_ref} className="flex flex-col h-full">
			<div className="flex-1 overflow-auto">


				<Controller
					name="disposalDate"
					control={control}
					rules={{ required: "Disposal Date Required" }}
					render={({ field: { value, onChange } }) => (
						<Datepicker
							label="Disposal Date"
							required
							value={value}
							//minDate={minDisposalDate}
							minDate={new Date(2025, 10, 1)} // November 2025 (month is 0-indexed)
							onChange={(e) => {
								onChange(e);
								// Recalculate useful life when disposal date changes
								if (e && e instanceof Date) {
									GetCurrentUsefullife(e);
								}
							}}
							error={errors.disposalDate?.message}
						/>
					)}
				/>

				<Controller
					name="disposalTypeID"
					rules={{ required: "Disposal Type is required" }}
					control={control}
					render={({ field: { value, onChange } }) => (
						<SelectBox
							label="Disposal Type"
							value={value}
							onChange={onChange}
							required
							placeholder="Choose Disposal Type"
							options={disposalTypeList ? disposalTypeList : []}
							error={errors.disposalTypeID?.message as any}
						/>
					)}
				/>
				<div className="bg-green-50 py-2 px-3">
					<h6 className="text-[0.813rem] font-semibold">Remaining Useful Life</h6>
					<p className="text-[0.813rem] font-normal mt-2">{Lifespan}</p>
				</div>

				<Controller

					name="saleAmount"
					control={control}
					rules={{ 
						required: WatchDisposalTypeID?.value !== 5 
							? "Sales Amount Required" 
							: false 
					}}
					render={({ field: { value, onChange } }) => (
						<Input
							label="Sales Amount"
							required={WatchDisposalTypeID?.value !== 5}
							type="number"
							disabled={disableSalesAmt}
							value={value}
							onChange={onChange}
							placeholder="Write Sales Amount Here"
							error={errors.saleAmount?.message}
						/>
					)}
				/>



				<Controller
					name="notes"
					rules={{ required: "Notes is required" }}
					control={control}
					render={({ field: { value, onChange } }) => (
						<Teaxtarea
							label="Notes"
							value={value}
							onChange={onChange}
							required
							placeholder="Write Your  Notes Here"
							error={errors.notes?.message}
						/>
					)}
				/>

				<Controller
					name='revaluationImage'
					control={control}
					render={({ field: { value, onChange } }) => (
						<FileUpload
							label='Upload Files'
							value={value}
							accept=".jpg, .jpeg, .png"
							onChange={(e: any) => {
								onChange(e.target.files[0])
							}}
							placeholder='Choose Processing Facility'

						/>
					)}
				/>
				{/* <div className={`mb-8`}>
					<div className="flex justify-between  mb-2 my-6 mx-4 pb-4  ml-0">
						<Label text={"JOURNAL ENTRIES"} isBold={true} />

					</div>
					<div className="max-w-[673px] rounded border border-[#043E6133] overflow-hidden">
						
						<div className="flex items-center bg-[#f0f0f0] h-[52px]">
							<div className="px-2 py-4 font-medium text-left text-[13px] text-[#262A2D] w-[calc(100%-220px)]">
								Account
							</div>
							<div className="px-2 py-4 font-medium text-right text-[13px] text-[#262A2D] w-[110px]">
								Debit ($)
							</div>
							<div className="px-2 py-4 font-medium text-right text-[13px] text-[#262A2D] w-[110px]">
								Credit ($)
							</div>
						</div>

						
						{journalEntries.length > 0 ? (
							journalEntries.map((row: any, index: number) => (
								<div key={index} className="flex items-center border-t border-[#043E6133]">
									<div className="px-2 py-2 text-left font-light text-[13px] text-[#262A2D] w-[calc(100%-220px)]">
										{row.accountDescription}
									</div>
									<div className="px-2 py-2 text-right font-light text-[13px] text-[#262A2D] w-[110px]">
										{row.type === 'debit' ? row.amount.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '------'}
									</div>
									<div className="px-2 py-2 text-right font-light text-[13px] text-[#262A2D] w-[110px]">
										{row.type === 'credit' ? row.amount.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '------'}
									</div>
								</div>
							))
						) : (
							<div className="flex items-center justify-center border-t border-[#043E6133] py-4 text-[13px] text-gray-500">
								No journal entries found.
							</div>
						)}

					</div>

				</div> 
				<hr className="border-gray-900" /> */}
			</div>
			<div className="flex justify-end gap-2 flex-shrink-0 pt-2 border-t border-gray-200">
				<Button type="button" theme="secondary" onClick={() => {
					formReset();
					onCancel()
				}}>
					Cancel
				</Button>
				<Button type="submit" working={false}>
					Save
				</Button>
			</div>
		</form>
	);
};

export default CreateDisposal;
